import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "types";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) =>
  state.underCarriageState || initialState;

export const selectUnderCarriageLoading = createSelector(
  [selectDomain],
  (underCarriageState) => underCarriageState.loading
);

export const selectUnderCarriageList = createSelector(
  [selectDomain],
  (underCarriageState) => underCarriageState.list
);

export const selectUnderCarriageMeta = createSelector(
  [selectDomain],
  (underCarriageState) => underCarriageState.meta
);

export const selectUnderCarriagePage = createSelector(
  [selectDomain],
  (underCarriageState) => underCarriageState.page
);

export const selectUnderCarriagePerPage = createSelector(
  [selectDomain],
  (underCarriageState) => underCarriageState.perPage
);

export const selectIsAddModalOpen = createSelector(
  [selectDomain],
  (underCarriageState) => underCarriageState.isAddModalOpen
);

export const selectUnderCarriageForm = createSelector(
  [selectDomain],
  (underCarriageState) => underCarriageState.form
);

export const selectUnderCarriageSaving = createSelector(
  [selectDomain],
  (underCarriageState) => underCarriageState.saving
);
